<template>
    <console-layout width="100%" max-width="1600">

        <console-title>
            <span>본인인증 목록</span>
        </console-title>

        <console-search @search="page=1; search(true)">
            <v-row align="center">
                <v-col cols="12" sm="3">
                    <v-select v-model="filter.searchKey" label="검색조건" persistent-placeholder hide-details :items="searchKeys" item-text="text" item-value="value" @input="filter.searchValue = null;"/>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field v-model="filter.searchValue" label="검색어" persistent-placeholder hide-details clearable :disabled="!filter.searchKey" @keydown.enter="page=1; search(true)" />
                </v-col>
            </v-row>
        </console-search>

        <console-body>
            <v-layout class="align-end">
                <span class="ception">검색된 본인인증 회원: {{ summary.totalCount.format() }}</span>
                <v-spacer />
            </v-layout>
    
            <v-data-table :loading="loading" :items="certs" :headers="membersHeaders" hide-default-footer disable-sort class="mt-2 elevation-1">
                <template #[`item.phone`]="{item}">
                    <span>{{ item.phone.phoneNumberFormat() }}</span>
                </template>
                <template #[`item.createdAt`]="{item}">
                    <span>{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
                </template>
            </v-data-table>
    
            <v-pagination v-model="page" :length="pageCount" total-visible="11" class="my-4" @input="search(true)" />
        </console-body>


    </console-layout>
</template>

<script>
import api from "@/api";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import { mdiMicrosoftExcel, mdiPlusCircleMultipleOutline, mdiRefresh, mdiAlertCircleOutline } from "@mdi/js";
import ConsoleContent from "@/templates/console/ConsoleContent.vue";

export default {
    components: {
        ConsoleContent,
        VDateField
    },
    data(){
        return {
            mdiRefresh,
            mdiMicrosoftExcel,
            mdiPlusCircleMultipleOutline,
            mdiAlertCircleOutline,

            showSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null
            },

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "이름", value: "name" },
                { text: "연락처", value: "phone" },
                { text: "생일", value: "birthday" }
            ],

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,
            loading: true,

            certs: [],
            summary: { totalCount: 0 },
            membersHeaders: [
                { text: "회원이름", value: "name", align: "center", width: "10%" },
                { text: "연락처", value: "phone", align: "center", width: "10%" },
                { text: "생일", value: "birthday", align: "center", width: "10%" },
                { text: "생성일자", value: "createdAt", align: "center", width: "15%" },
                { text: "CI 값", value: "ci", align: "left", width: "70%" }
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            await this.search();
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            this.loading = true;
            this.certs = [];
            let { summary, certs } = await api.console.auth.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            })
            this.loading = false;
            this.certs = certs;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        }
    }
}
</script>